import { render, staticRenderFns } from "./notificationsOrAlerts.vue?vue&type=template&id=18245160&scoped=true"
import script from "./notificationsOrAlerts.vue?vue&type=script&lang=js"
export * from "./notificationsOrAlerts.vue?vue&type=script&lang=js"
import style0 from "./notificationsOrAlerts.vue?vue&type=style&index=0&id=18245160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18245160",
  null
  
)

export default component.exports